import React from 'react'
import FolderIcon from '../../icons/FolderIcon'
import FileIcon from '../../icons/FileIcon'
import TagIcon from '../../icons/TagIcon'
import useStyles from './styles'
import Tooltip from '../Tooltip'

const FOLDER = 'folder'

const ArticleTags = ({ tags }) => {
  const classes = useStyles()
  const count = tags.length

  if (tags.length === 0) return null

  if (count > 2) {
    return (
      <div className={classes.tagContainer}>
        {tags.slice(0, 2).map((tag, idx) => (
          <span key={`${tag}-${idx}`}>
            <TagIcon />
            {tag}
          </span>
        ))}
        <span className={classes.remainingTag}>{`+${count - 2} more`}</span>
      </div>
    )
  }

  return (
    <div className={classes.tagContainer}>
      {tags.map((tag, idx) => (
        <span key={`${tag}-${idx}`}>
          <TagIcon />
          {tag}
        </span>
      ))}
    </div>
  )
}

const ArticleType = ({ type, items, title, tags, total_items, onClick }) => {
  const titleText =
    type === FOLDER ? `${title} (${total_items || '0'})` : `${title}`

  const classes = useStyles()

  if (type === FOLDER) {
    return (
      <td onClick={onClick} className={classes.root} role='cell'>
        <Tooltip title={titleText} arrow>
          <div className={classes.tooltipContainer}>
            <FolderIcon />
            <label>{titleText}</label>
          </div>
        </Tooltip>
      </td>
    )
  }

  return (
    <td onClick={onClick} className={classes.root} role='cell'>
      <div className={classes.articleRoot}>
        <Tooltip title={titleText} arrow>
          <div className={classes.tooltipContainer}>
            <FileIcon />
            <label>{titleText}</label>
          </div>
        </Tooltip>
        <ArticleTags tags={tags} />
      </div>
    </td>
  )
}

export default ArticleType
